const firebaseConfig = {
  apiKey: "AIzaSyDHGjmgS75sH1oKd2OvtMDaeP8woyi48W4",
  authDomain: "volunteer-network-123.firebaseapp.com",
  databaseURL: "https://volunteer-network-123.firebaseio.com",
  projectId: "volunteer-network-123",
  storageBucket: "volunteer-network-123.appspot.com",
  messagingSenderId: "558688696693",
  appId: "1:558688696693:web:867cb70414f0d2df54fb3c"
};
export default firebaseConfig;